// @flow

import URI from 'urijs';
import fetchUrl, { fetchJson, postJson } from 'utils/fetch';
import type { Thread } from '../types';

type FetchProps = {
  search: ?string,
  unread: boolean,
  tracked: boolean,
};

export const fetchThreads = ({ search, unread, tracked }: FetchProps) => {
  const uri = new URI('/mc/messaging/threads.json')
    .search({
      search,
      unread,
      tracked,
    })
    .toString();

  return fetchJson(uri);
};

type CreateProps = {
  user: number,
};

export const createThread = ({ user }: CreateProps) =>
  postJson('/mc/messaging/threads', {
    user: parseInt(user, 10),
  });

type TrackProps = {
  thread: string,
  value: boolean,
};

export const trackThread = ({ thread, value }: TrackProps) => {
  return fetchUrl(`/mc/messaging/threads/${thread}/track`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      value,
    }),
  });
};

type ReadProps = {
  thread: string,
  upToIndex: number,
};

export const readThread = ({
  thread,
  upToIndex,
}: ReadProps): Promise<Thread> => {
  return fetchUrl(
    `/mc/messaging/threads/${thread}/read?up_to_index=${upToIndex}`,
    {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    }
  ).then(res => res.json());
};



// WEBPACK FOOTER //
// ./src/modules/messaging/api/threads.js